import { FC, ReactNode } from 'react';
import { Icon } from 'components';

import close from 'assets/sprite/close.svg';

import styles from './Modal.module.scss';

interface IModal {
  children: ReactNode;
  setIsShow: (boolean: boolean) => void;
}

export const Modal: FC<IModal> = ({ children, setIsShow }) => {
  return (
    <div
      className={styles.root}
      onClick={() => {
        setIsShow(false);
      }}
    >
      <div
        className={styles.inner}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {children}
        <button
          className={styles.close}
          onClick={() => {
            setIsShow(false);
          }}
        >
          <Icon id={close.id} viewBox={close.viewBox} className={styles.icoClose} />
        </button>
      </div>
    </div>
  );
};
